import api from '../../api.js';

export const ACCORDIONS_GROUP = api.core.ns('accordions-group');
export const ACCORDION_ASCENDANT = api.core.ns('accordion');
